import { actionTypes } from './constants';
import { get, post } from 'src/fetch/fetch';
import { CART_PRODUCT_DEL_POST, CART_PRODUCT_MOD_POST, CART_GET_GET } from 'src/fetch/url';
import { setMessage } from 'src/store/global/actionCreators';


export function initCart(data) {
  return {
    type: actionTypes.INIT_CART,
    data,
  };
}
export function setCart(data) {
  return {
    type: actionTypes.SET_CART,
    data
  };
}
export function toggleCheckItem(data) {
  return {
    type: actionTypes.TOGGLE_CHECK_ITEM,
    data
  };
}

export function toggleCheckAll() {
  return {
    type: actionTypes.TOGGLE_CHECK_ALL,
  };
}

export function changeProductNumber(data) {
  return {
    type: actionTypes.CHANGE_PRODUCT_NUMBER,
    data,
  };
}

export function deleteProducts(data) {
  return {
    type: actionTypes.DELETE_PRODUCTS,
    data
  };
}

export function fetchDeleteProducts(data) {
  return function (dispatch) {
    const params = data;
    post(CART_PRODUCT_DEL_POST, params)
      .then(res => { 
        if (res.success) {
          dispatch(deleteProducts(params));
          // dispatch(setMessage({ type: 'success', msg: res.message }));
        }
      })
      .catch(err => {
        dispatch(setMessage({ type: 'error', msg: '请求失败' }));
      });
  };
}


export function fetchChangeProductNumber({ id, productId, amount }, cb) {
  return (dispatch) => {
    const params ={ id, productId, amount };
    post(CART_PRODUCT_MOD_POST, params)
      .then(res => {
        if (res.success) {
          dispatch(setMessage({ type: 'success', msg: res.message }));
          dispatch(changeProductNumber(params));
          cb();
        } else {
          dispatch(setMessage({ type: 'error', msg: res.message }));
        }
      })
      .catch(err => {
        dispatch(setMessage({ type: 'error', msg: err.message || '请求异常' }));
      });

  };
}


export function fetchInitCart() {
  return dispatch => {
    get(CART_GET_GET)
      .then(res => {
        if (res.success) {
          dispatch(initCart({ cart: res.content.rows} ));
        } else {
          dispatch(setMessage({ type: 'error', msg: res.message }));
        }
      })
      .catch(err => {
        dispatch(setMessage({ type: 'error', msg: err.message || '请求异常' }));
      });
  };
}